<template>
  <div>
    <input type="text" className="form-control" placeholder="" v-model="propsValue">

    <h1>骨科</h1>

    <div class="shadow p-3 mb-5 bg-white rounded">
      定量式超音波(QUS)
    </div>
    <div class="shadow p-3 mb-5 bg-white rounded">
      定量式超音波(DEXA)
    </div>
    <div class="shadow p-3 mb-5 bg-white rounded">
      超音波導引注射療法Echo-guided injection
    </div>
    <div class="shadow p-3 mb-5 bg-white rounded">
      <h2>看診紀錄：</h2>
      <button class="btn btn-primary" >歷史資料</button>
      <textarea class="form-control" id="txtMemo" name="txtMemo" rows="10"></textarea>

      歷史資料
      <textarea class="form-control" id="txtMemo" name="txtMemo" rows="10" style="color: gray"></textarea>
    </div>

  </div>
</template>

<script>
/**

 **/


export default {
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data: function () {
    return {
      id: "",
      dataReady: false,
      propsValue: this.value,
      formData: {
        name: "",
      },
    };
  },
  watch: {
    propsValue(newVal) {
      //this.('input', newVal);
      this.$emit('input', newVal);
    },
    value(newVal) {
      this.propsValue = newVal
    }
  },
  methods: {
    //給予value屬性預設值
    initValue() {
      const isMyObjectEmpty = !Object.keys(this.value).length;

      if (isMyObjectEmpty) {
        let template = {...this.datasDemo};
        this.value = template;
      }
    },
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
  },
  mounted() {
    // this.initValue()
    //this.loadData()
  },
}
</script>

<style scoped>

</style>
